































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonAddFailureTracking extends Vue {
  cancel = false;

  getRouteAddFailureTracking() {
    return this.$router.push({ name: "add-failure-tracking" });
  }

  onExport() {
    this.$store.commit("EXPORT");
  }
}
